var exports = {
  "ne": "CardAlignmentControls.module__controls___TGNoZ2",
  "DK": "CardAlignmentControls.module__controlsDisabled___TGNoZ2",
  "x6": "CardAlignmentControls.module__button___TGNoZ2",
  "rK": "CardAlignmentControls.module__buttonActive___TGNoZ2",
  "$9": "CardAlignmentControls.module__buttonDisabled___TGNoZ2",
};

module.exports = exports;
